.accommodationBlockingDelete {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  max-width: 900px;
}

.heading {
  margin: 0;
}

.actions {
  display: flex;
  gap: 1rem;
  margin-top: 1rem;
}
